<div id="applicationsInProgress" class="modal" materialize="modal" [materializeParams]="[{dismissible: false}]">
    <div class="modal-header">
        <div class="zest-logo">
            <img src="../../assets/images/zest-logo.svg" />
        </div>
    </div>
    <div class="container">
        <div class="card" *ngIf="!isMerchantKeyAvailable && inProgressWithoutApproved.length > 1">
            <div class="modal-content">
                <p class="text-center">Looks like you are in the middle of 2 loan applications. Please choose one to continue.</p>
                <div class="row no-margin">
                    <ul class="application-options">
                        <li class="col s6" *ngFor="let application of inProgressWithoutApproved; let i=index ">
                            <input class="with-gap" name="" type="radio" [id]="'application'+i" [value]="i" (click)="selectApplication(i)" [(ngModel)]="applicationChosen"
                            />
                            <label class="currency" [for]="'application'+i" *ngIf="inProgressOrders[i]">
                                <div class="merchant text-center">
                                    <img class="merchant-logo" [src]="s3BucketUrl+'/logo-icons/'+(inProgressOrders[i].MerchantName|lowercase)+'-logo-icon.png'"
                                    />
                                    <br/>
                                    <span [textContent]="inProgressOrders[i].BasketItems.length > 0 ? (inProgressOrders[i].BasketItems[0].Description | truncate : 20) : inProgressOrders[i].MerchantName"></span>
                                </div>
                                <div class="progress-bar" *ngIf="progressBarValues.length>0">
                                    <div class="current-progress" [ngStyle]="{'width': progressBarValues[i] + '%', 'background': '#1eba68'}"></div>
                                </div>
                                <div class="emi-details text-center">
                                    <span>Order Amount:
                                        <br/>{{inProgressOrders[i].BasketAmount | RupeeCurrencyPipe}}</span>
                                    <br/>
                                    <span>EMI: {{inProgressOrders[i].TotalInstallmentAmount | RupeeCurrencyPipe}}/mo</span>
                                    <br/>
                                    <span>{{inProgressOrders[i].NumberOfInstallments}} months</span>
                                </div>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="modal-footer text-center no-padding">
                <p class="fixed-width text-center" [ngStyle]="{'opacity': checkRadio}">
                    By continuing, the other loan application gets cancelled.
                    <span *ngIf="isExtendedApiMerchant" [textContent]="'You will be redirected to Mi.com to continue the loan application.'"></span>
                </p>
                <button type="button" [class]="processing?'btn waves-effect zest-btn processing ladda-button':'btn waves-effect zest-btn ladda-button'"
                    [ladda]="processing" [disabled]="processing || !checkRadio" (click)="continue(applicationChosen, true)">Continue</button>
            </div>
        </div>
        <div class="card" *ngIf="inProgressWithoutApproved.length === 1 && inProgressExtendedApiMerchant.length === 1">
            <div class="modal-content">
                <p class="text-center">You started an application for credit on Mi.com tap below to resume</p>
                <div class="row no-margin">
                    <ul class="application-options">
                        <li class="col s12" *ngFor="let application of inProgressExtendedApiMerchant; let i=index ">
                            <div class="application-info-box" *ngIf="inProgressOrders[i]" (click)="goBackToExtendedApiMerchant(inProgressOrders[i])">
                                <div class="merchant text-center">
                                    <img class="merchant-logo" [src]="s3BucketUrl+'/logo-icons/'+(inProgressOrders[i].MerchantName|lowercase)+'-logo-icon.png'"
                                    />
                                    <br/>
                                    <span [textContent]="inProgressOrders[i].BasketItems.length > 0 ? (inProgressOrders[i].BasketItems[0].Description | truncate : 20) : inProgressOrders[i].MerchantName"></span>
                                </div>
                                <div class="progress-bar" *ngIf="progressBarValues.length>0">
                                    <div class="current-progress" [ngStyle]="{'width': progressBarValues[i] + '%', 'background': '#1eba68'}"></div>
                                </div>
                                <div class="emi-details text-center">
                                    <span>Order Amount:
                                        <br/>{{inProgressOrders[i].BasketAmount | RupeeCurrencyPipe}}</span>
                                    <br/>
                                    <span>EMI: {{inProgressOrders[i].TotalInstallmentAmount | RupeeCurrencyPipe}}/mo</span>
                                    <br/>
                                    <span>{{inProgressOrders[i].NumberOfInstallments}} months</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="modal-footer text-center no-padding">
                <button type="button" class="btn-flat zest-flat-btn" (click)="goToZest()">GO TO HOME</button>
            </div>
        </div>
        <div class="card" *ngIf="isMerchantKeyAvailable && merchantConfig && inProgressWithoutApproved.length >= 1">
            <div class="modal-content">
                <p class="text-center">Looks like you are in the middle of 2 applications. Please choose one to continue.</p>
                <div class="row no-margin">
                    <ul class="application-options">
                        <li class="col s6">
                            <input class="with-gap" name="" type="radio" [id]="'application'+0" [value]="0" (click)="selectApplication(0)" [(ngModel)]="applicationChosen"
                            />
                            <label class="currency" [for]="'application'+0" *ngIf="inProgressOrders[0]">
                                <div class="merchant text-center">
                                    <img class="merchant-logo" [src]="s3BucketUrl+'/logo-icons/'+(inProgressOrders[0].MerchantName|lowercase)+'-logo-icon.png'"
                                    />
                                    <br/>
                                    <span [textContent]="inProgressOrders[0].BasketItems.length > 0 ? (inProgressOrders[0].BasketItems[0].Description | truncate : 20) : inProgressOrders[0].MerchantName"></span>
                                </div>
                                <div class="progress-bar" *ngIf="progressBarValues.length>0">
                                    <div class="current-progress" [ngStyle]="{'width': progressBarValues[0] + '%', 'background': '#1eba68'}"></div>
                                </div>
                                <div class="emi-details text-center">
                                    <span>Order Amount:
                                        <br/>{{inProgressOrders[0].BasketAmount | RupeeCurrencyPipe}}</span>
                                    <br/>
                                    <span>EMI: {{inProgressOrders[0].TotalInstallmentAmount | RupeeCurrencyPipe}}/mo</span>
                                    <br/>
                                    <span>{{inProgressOrders[0].NumberOfInstallments}} months</span>
                                </div>
                            </label>
                        </li>
                        <li class="col s6">
                            <input class="with-gap" name="" type="radio" id="application1" value="1" (click)="selectApplication(1)" [(ngModel)]="applicationChosen"
                            />
                            <label class="currency" [for]="'application'+1">
                                <div class="merchant text-center">
                                    <img class="merchant-logo" [src]="s3BucketUrl+'/logo-icons/credit-application-logo-icon.png'"
                                    />
                                    <br/>
                                    <span>Credit limit <span class="hide-on-small-only"> application</span></span>
                                </div>
                                <div class="progress-bar">
                                    <div class="current-progress" [ngStyle]="{'width': 50 + '%', 'background': '#1eba68'}"></div>
                                </div>
                                <div class="emi-details fixed-height text-center">
                                    <span>Complete and redeem your credit limit at our partner merchants</span>
                                </div>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="modal-footer text-center no-padding">
                <p class="fixed-width text-center" [ngStyle]="{'opacity': checkRadio}">
                    By continuing, the other loan application gets cancelled.
                    <span *ngIf="isExtendedApiMerchant" [textContent]="'You will be redirected to Mi.com to continue the loan application.'"></span>
                </p>
                <button type="button" [class]="processing?'btn waves-effect zest-btn processing ladda-button':'btn waves-effect zest-btn ladda-button'"
                    [ladda]="processing" [disabled]="processing || !checkRadio" (click)="continue(applicationChosen)">Continue</button>
            </div>
        </div>
    </div>
</div>